import clsx from 'clsx'

import textLogo from '@/images/logo-text.svg'

import Image from 'next/image'

type Props = {
  className?: string
}

export function TextLogo({ className }: Props) {
  return (
    <div className={clsx(className, 'w-36')}>
      <Image
        src={textLogo}
        alt="NextClinic"
        priority={true}
        className="w-full"
      />
    </div>
  )
}
